'use strict';

// Needed for async/await
import '@babel/polyfill';

import Vue    from 'vue';
import Vuex   from 'vuex';
Vue.use(Vuex);

// Build devtools
Vue.config.devtools = true;

import './stylesheets/app.sass';

// Routes
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';
const router = new VueRouter({
  routes
});

// Analytics
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: process.env.NODE_ENV === 'production' ? 'UA-47272514-2' :'UA-47272514-3',
  router,
  ecommerce: {
    enabled: true
  }
});

import api               from './api';
import store             from './store';

import axios from 'axios';

// Moment setup
import moment from 'moment';
moment.updateLocale('en', {
  relativeTime: {
    s:  'secs',
    ss: '%ds',
    m:  '%dm',
    mm: '%dm',
    h:  '%dh',
    hh: '%dh',
    d:  '%dd',
    dd: '%dd',
    M:  '%dM',
    MM: '%dM',
    y:  '%dy',
    yy: '%dy'
  }
});

// Register global components
import PinhighSelect from './components/pinhigh-select.vue';
Vue.component('pinhigh-select', PinhighSelect);
import PinhighTable from './components/pinhigh-table.vue';
Vue.component('pinhigh-table', PinhighTable);
import PinhighModal from './components/pinhigh-modal.vue';
Vue.component('pinhigh-modal', PinhighModal);

// Register global filters
import pinhighDisplayStrokes from './filters/pinhigh-display-strokes';
Vue.filter('pinhighDisplayStrokes', pinhighDisplayStrokes);
import pinhighDisplayTotalStrokes from './filters/pinhigh-display-total-strokes';
Vue.filter('pinhighDisplayTotalStrokes', pinhighDisplayTotalStrokes);
import pinhighDisplayThrough from './filters/pinhigh-display-through';
Vue.filter('pinhighDisplayThrough', pinhighDisplayThrough);
import pinhighDisplayPlayerPosition from './filters/pinhigh-display-player-position';
Vue.filter('pinhighDisplayPlayerPosition', pinhighDisplayPlayerPosition);
import pinhighDisplayParticipantPosition from './filters/pinhigh-display-participant-position';
Vue.filter('pinhighDisplayParticipantPosition', pinhighDisplayParticipantPosition);
import pinhighDate from './filters/pinhigh-date';
Vue.filter('pinhighDate', pinhighDate);

import MainView from './components/main-view.vue';

const app = new Vue({
  el: '#app',
  render:  h => h(MainView),
  store,
  router,
  created: function() {
    // If environment set in body tag, use it
    const body = document.querySelector('body[vue-env]');
    if (body && body.getAttribute('vue-env')) {
      api.configure({env: body.getAttribute('vue-env')});
    }

    // Setup axios interceptors here so we have access to the router
    axios.interceptors.request.use(config => {
      const currentUser = this.$store.getters.currentUser;
      if (currentUser) {
        config.headers['AUTH-EMAIL'] = currentUser.email;
        config.headers['AUTH-TOKEN'] = currentUser.token;
      }
      return config;
    });
    axios.interceptors.response.use(response => response, err => {
      // If a call that requires auth is made and server says it's invalid, log user out
      if (err.response.data.auth === false) {
        this.$store.dispatch('logOut');
        this.$store.dispatch('messages/setMessage', {key: 'loginMessage', message: 'Please login again'});
        this.$router.push({name: 'login'});
        return Promise.reject();
      } else {
        return Promise.reject(err);
      }
    });

    // If user logged in, send a request for user object and update store
    if (this.$store.getters.isLoggedIn) {
      api.User.show({params: {id: this.$store.getters.currentUser.id}})
        .then(user => this.$store.commit('logIn', user));
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    currentUserSolvent() {
      return this.currentUser ? this.currentUser.payments_solvent : false;
    },
    currentUserSolventThrough() {
      return this.currentUserSolvent ? moment(this.currentUser.payments_solvent_through).format('MMM Do, YYYY') : null;
    },
    currentUserSolventThrough4Days() {
      return this.currentUserSolvent && moment(this.currentUser.payments_solvent_through).isAfter(moment().add(4, 'days'));
    },
    env() {
      return process.env.NODE_ENV || 'development';
    },
    stripePublishableKey() {
      return process.env.VUE_APP_STRIPE_KEY;
    }
  },
  methods: {
    ...Vuex.mapMutations('paymentModal', {togglePaymentModal: 'toggle'})
  }
});

// This fires when mobile app is loaded
window.handleOpenURL = url => {
  setTimeout(function(){
    app.$router.push(url.split('#')[1]);
  }, 100);
};
